import script from "./Form51Receipt.vue?vue&type=script&setup=true&lang=js"
export * from "./Form51Receipt.vue?vue&type=script&setup=true&lang=js"

import "./Form51Receipt.vue?vue&type=style&index=0&id=61def448&lang=css"

const __exports__ = script;

export default __exports__